(() => {
  if (window.PDIAds) return;
  const tagId = 'AW-18121212761';
  let initialized = false;
  function permissions() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      const choice = privacy?.currentVisitorConsent();
      return {
        marketing: privacy?.marketingAllowed() === true && choice?.marketing === 'yes',
        analytics: privacy?.analyticsProcessingAllowed() === true && choice?.analytics === 'yes'
      };
    } catch (error) {
      return { marketing: false, analytics: false };
    }
  }
  function syncConsent() {
    const allowed = permissions();
    window.gtag('consent', 'update', {
      ad_storage: allowed.marketing ? 'granted' : 'denied',
      ad_user_data: allowed.marketing ? 'granted' : 'denied',
      ad_personalization: allowed.marketing ? 'granted' : 'denied',
      analytics_storage: allowed.analytics ? 'granted' : 'denied'
    });
    if (!allowed.marketing || initialized) return;
    initialized = true;
    if (!Array.from(document.scripts).some(script => script.src.startsWith('https://www.googletagmanager.com/gtag/js?') && new URL(script.src).searchParams.get('id') === tagId)) {
      const script = document.createElement('script');
      script.id = 'pdi-google-ads-consented';
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + tagId;
      script.async = true;
      document.head.append(script);
    }
    window.gtag('js', new Date());
    window.gtag('config', tagId);
  }
  window.PDIAds = {
    conversion(label) {
      if (!permissions().marketing) return;
      syncConsent();
      window.gtag('event', 'conversion', { send_to: tagId + '/' + label, value: 1, currency: 'EUR' });
    }
  };
  document.addEventListener('visitorConsentCollected', syncConsent);
  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link) return;
    try {
      const target = new URL(link.href);
      if (['wa.me', 'api.whatsapp.com', 'www.whatsapp.com', 'whatsapp.com'].includes(target.hostname) && target.protocol === 'https:') {
        window.PDIAds.conversion('6blQCO0uqqocENmG78BD');
      }
    } catch (error) {}
  }, true);
  function initializePrivacy(attempt = 0) {
    if (window.Shopify?.customerPrivacy) { syncConsent(); return; }
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => { if (!error) syncConsent(); });
    } else if (attempt < 20) {
      setTimeout(() => initializePrivacy(attempt + 1), 250);
    }
  }
  initializePrivacy();
})();
